import SharedErrorBoundary from '../../shared/shared-error-boundary';
import { isFeatureEnabled } from '../../utils/feature-flags';
import SupportAgent from './support-agent';

interface SupportAgentGateProps {
  features: Record<string, boolean> | null | undefined;
}

export default function SupportAgentGate({ features }: SupportAgentGateProps) {
  if (!isFeatureEnabled('supportAgentEnabled', features ?? null)) {
    return null;
  }

  // Stay mounted while the feature is on so chat history and drag position
  // survive close/reopen. Visibility is handled inside SupportAgent.
  return (
    <SharedErrorBoundary section="Support Agent">
      <SupportAgent />
    </SharedErrorBoundary>
  );
}
